import { createFileRoute } from '@tanstack/react-router'
import { UsingAiPage } from '@/components/infoPages/UsingAiPage'
import { withPublicPageSeo } from '@/modules/seo'

const UsingAiPageWithSeo = withPublicPageSeo('aiJudgment', UsingAiPage)

export const Route = createFileRoute('/using-ai-without-outsourcing-judgment')({
  component: UsingAiPageWithSeo,
})
